import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/lp-logo-white.svg'


const _hoisted_1 = { class: "ly-col ly-center-center reset-password-container" }
const _hoisted_2 = { class: "card" }

import { onMounted, inject } from 'vue'
import { useConfig } from '@/config/useConfig'


export default /*@__PURE__*/_defineComponent({
  __name: 'RefreshAccessTokenError',
  setup(__props) {

const postMessageToParentWindow = inject('postMessageToParentWindow') as (message: object, target: string) => void

const closeWindow = () => {
  window.close()
}

onMounted(async () => {
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'refreshFailed' }, config.sso.lms_url)
})


return (_ctx: any,_cache: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      class: "mb-3"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Your Session could not be refreshed", -1)),
      _createVNode(_component_lp_button, { onClick: closeWindow }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Close this window", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})